export const URL_INVENTARIO_TARJETA =
    '/Inventario/WebService/InventarioWebService.asmx/buscarTarjetasDashboard'
export const URL_ITEMS_GRID_DASHBOARD =
    '/Inventario/WebService/InventarioWebService.asmx/buscarItemsGridDashboard'
export const URL_ITEMS_AUTOCOMPLETE_DASHBOARD =
    '/Inventario/WebService/ItemWebService.asmx/BuscarListadoItems'
export const URL_INVENTARIO_PROMEDIO_GRAFICO_DASHBOARD =
    '/Inventario/WebService/InventarioWebService.asmx/BuscarInventarioPromedioGrafico'
export const URL_ALMACENES =
    '/Inventario/WebService/InventarioWebService.asmx/BuscarAlmacenes'
export const URL_CATEGORIAS =
    '/Inventario/WebService/InventarioWebService.asmx/BuscarCategorias'
export const URL_SUB_CATEGORIAS =
    '/Inventario/WebService/InventarioWebService.asmx/BuscarSubCategorias'
export const URL_FAMILIAS =
    '/Inventario/WebService/InventarioWebService.asmx/BuscarFamilias'

export const URL_BUSCAR_INVENTARIO_PROMEDIO_GRAFICO_POR_ITEM =
    '/Inventario/WebService/InventarioWebService.asmx/BuscarInventarioPromedioPorItemGrafico'
export const URL_EXPORTAR_ITEMS_GRID = 
    '/Inventario/WebService/InventarioWebService.asmx/ExportarItemsGrid'